import { BACKGROUND_GENERATION_STEPS_CONSTANTS } from "@/app/(protected)/background-generation/constants";

export const STEP_NUMBERS = {
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5,
};

export const campaignSteps = [
  { step: STEP_NUMBERS.ONE, label: "Project brief" },
  { step: STEP_NUMBERS.TWO, label: "Campaign details" },
  { step: STEP_NUMBERS.THREE, label: "Concept options" },
  { step: STEP_NUMBERS.FOUR, label: "Concept write up" },
];

export const assetGenerationSteps = [
  { step: STEP_NUMBERS.ONE, label: "Explore options" },
  { step: STEP_NUMBERS.TWO, label: "Add inputs" },
  { step: STEP_NUMBERS.THREE, label: "Start creating" },
  { step: STEP_NUMBERS.FOUR, label: "Review assets" },
];
export const pdpSteps = [
  { step: STEP_NUMBERS.ONE, label: "Select options" },
  { step: STEP_NUMBERS.TWO, label: "Generate images" },
  { step: STEP_NUMBERS.THREE, label: "Image review" },
];

export const pdpCopySteps = [
  { step: STEP_NUMBERS.ONE, label: "Project brief" },
  { step: STEP_NUMBERS.TWO, label: "Project copy list" },
  { step: STEP_NUMBERS.THREE, label: "Generated copy" },
];

export const BACKGROUND_GENERATION_STEPS = [
  { step: STEP_NUMBERS.ONE, label: BACKGROUND_GENERATION_STEPS_CONSTANTS.STEP_NAMES[1] },
  { step: STEP_NUMBERS.TWO, label: BACKGROUND_GENERATION_STEPS_CONSTANTS.STEP_NAMES[2] },
  { step: STEP_NUMBERS.THREE, label: BACKGROUND_GENERATION_STEPS_CONSTANTS.STEP_NAMES[3] },
];

export const GTM_USERFLOW = {
  CONCEPTING: "Start Concepting",
  PDP_COPY: "Draft PDP Copy",
  ASSET_GENERATION: "Create Asset Generation",
  ASSET_GENERATION_LINK: "Asset Generation",
  LIFESTYLE: "Generate Lifestyle Images",
  BACKGROUND_GENERATION: "Generate Background Images",
  VIDEO_GENERATION: "Video Generation",
  CONTENT_GENERATION: "Content Generation",
  STORY_BOARD: "Story Board",
  IMAGE_EDITING: "Image Editing",
};
